import clone from 'clone';
import Vue from 'vue';
import URI from 'urijs';
import Mixins from './mixins';

export default class RequestFactory {
	constructor(apiClient, options = {}) {
		this.apiClient = apiClient;
		this.options = {};

		let _options = {
			noErrorHandler: false,
			raw: false,
		};

		for (let option in options) {
			_options[option] = options[option];
		}

		this.setOptions(_options);
	}

	noErrorHandler() {
		return this.setOption('noErrorHandler', true);
	}

	raw() {
		return this.setOption('raw', true);
	}

	setOption(option, value) {
		this.options[option] = value;

		return this;
	}

	setOptions(options) {
		for (let option in options) {
			this.setOption(option, options[option]);
		}

		return this;
	}

	get(endPoint, getParams = null) {
		return this.request('get', endPoint, getParams, {});
	}

	post(endPoint, data = null, getParams = null) {
		return this.request('post', endPoint, getParams, data);
	}

	put(endPoint, data = null, getParams = null) {
		return this.request('put', endPoint, getParams, data);
	};
	delete(endPoint, data = null, getParams = null) {
		return this.request('delete', endPoint, getParams, data);
	};
	request(type, endPoint, getParams, data) {
		getParams = getParams || null;

		return this.apiClient.request(type, endPoint, getParams, data, this.options);
	}
}